import React from 'react';

import styles from './main.module.scss';

interface IProps {
  children: JSX.Element | JSX.Element[];
}

const Main: React.FC<IProps> = ({ children }) => (
  <div className={styles.main}>{children}</div>
);

export default Main;
